import { useEffect, useState } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";

type Strength = "weak" | "medium" | "strong";

interface PasswordCriteriasProps {
    password: string;
    onMet: (met: boolean) => void;
}

const PasswordCriterias = ({ password, onMet }: PasswordCriteriasProps) => {
    const [has8, setHas8] = useState(false);
    const [hasUpper, setHasUpper] = useState(false);
    const [hasLower, setHasLower] = useState(false);
    const [hasNumber, setHasNumber] = useState(false);
    const [strength, setStrength] = useState<Strength>("weak");

    useEffect(() => {
        const upper = /[A-Z]/.test(password);
        const lower = /[a-z]/.test(password);
        const num = /[0-9]/.test(password);
        const len = password.length >= 8;
        setHasUpper(upper);
        setHasLower(lower);
        setHasNumber(num);
        setHas8(len);
        const count = [upper, lower, num, len].filter(Boolean).length;
        onMet(count === 4);
        if (count <= 2) setStrength("weak");
        else if (count === 3) setStrength("medium");
        else setStrength("strong");
    }, [password, onMet]);

    const strengthLabel = strength === "weak" ? "i dobët" : strength === "medium" ? "i mesëm" : "i fortë";
    const strengthColor = strength === "weak" ? "text-red-600" : strength === "medium" ? "text-amber-600" : "text-green-600";

    return (
        <div className="rounded-lg bg-gray-50 p-3 space-y-1.5 text-sm">
            <p className={`font-medium ${strengthColor}`}>Niveli: {strengthLabel}</p>
            <div className="flex items-center gap-2">
                {has8 ? <FaCheck className="text-green-600" /> : <FaTimes className="text-red-500" />}
                <span className={has8 ? "text-gray-800" : "text-red-600"}>Së paku 8 shkronja</span>
            </div>
            <div className="flex items-center gap-2">
                {hasUpper ? <FaCheck className="text-green-600" /> : <FaTimes className="text-red-500" />}
                <span className={hasUpper ? "text-gray-800" : "text-red-600"}>Së paku një shkronjë të madhe</span>
            </div>
            <div className="flex items-center gap-2">
                {hasLower ? <FaCheck className="text-green-600" /> : <FaTimes className="text-red-500" />}
                <span className={hasLower ? "text-gray-800" : "text-red-600"}>Së paku një shkronjë të vogël</span>
            </div>
            <div className="flex items-center gap-2">
                {hasNumber ? <FaCheck className="text-green-600" /> : <FaTimes className="text-red-500" />}
                <span className={hasNumber ? "text-gray-800" : "text-red-600"}>Së paku një numër</span>
            </div>
        </div>
    );
};

export default PasswordCriterias;
